"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQrCodeEvent = void 0;
var OpenQrCode = _interopRequireWildcard(require("@ori-events/open-qr-code-dialog"));
var _logger = require("@ori/logger");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useQrCodeEvent = () => {
  const logger = (0, _logger.useLogger)('useQrCodeEvent');
  const [qrCodeData, setQrCodeData] = (0, _react.useState)(null);
  const {
    initialOpenDone,
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useInitialDisclose)();
  const onOpenQrCode = (0, _react.useCallback)(({
    detail: {
      url,
      placement,
      position,
      gamificationActivityType
    }
  }) => {
    if (url.length >= _utils.RECOMMENDED_URL_LENGTH) {
      logger.info(`URL bigger then recommended length: ${url}, length: ${url.length}`);
    }
    setQrCodeData({
      url,
      placement,
      position,
      gamificationActivityType
    });
    onOpen();
  }, [onOpen, logger]);
  const events = (0, _react.useMemo)(() => [{
    name: OpenQrCode.Name,
    listener: onOpenQrCode
  }], [onOpenQrCode]);
  (0, _presentationHooks.useGlobalEvents)(events);
  return {
    data: qrCodeData,
    initialOpenDone,
    onClose,
    open
  };
};
exports.useQrCodeEvent = useQrCodeEvent;
